import { dataUriToBuffer } from 'data-uri-to-buffer'

type DecodedImage =
  | { type: 'image/svg+xml'; isSvg: true; source: string }
  | { type: string; isSvg: false; buffer: ArrayBuffer; srcInBase64: string | null }

export default function decodeImage(src: string | null | undefined): DecodedImage | null {
  if (!src) {
    return null
  }

  if (src.startsWith('data:image')) {
    const { type, buffer } = dataUriToBuffer(src)

    if (type === 'image/svg+xml') {
      return {
        type,
        isSvg: true,
        source: new TextDecoder().decode(buffer),
      }
    }

    if (/^data:image\/.*;base64,/i.test(src)) {
      return {
        type,
        isSvg: false,
        buffer,
        srcInBase64: src,
      }
    }

    return {
      type,
      isSvg: false,
      buffer,
      srcInBase64: null,
    }
  }

  if (src.startsWith('<?xml version="1.0" encoding="UTF-8" standalone="no"?>') || src.startsWith('<svg')) {
    return {
      type: 'image/svg+xml',
      isSvg: true,
      source: src,
    }
  }

  return null
}
